export const newProvidersList = []